import React, { useEffect, useState } from 'react';
import { CardContent } from '../ui/Card';
import { Button } from '../ui/Button';
import { lotteryService } from '../../services/lotteryService';
import { formatMoney } from '../../utils/formatMoney';
import { PrizeDigits } from './PrizeDigits';

export function CountdownTimer({ onBuyLotteryClick }) {
  const [period, setPeriod] = useState(null);
  const [prizes, setPrizes] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);

  useEffect(() => {
    const load = () => {
      Promise.all([
        lotteryService.getActivePeriod(),
        lotteryService.getPrizes(),
      ])
        .then(([periodData, prizesData]) => {
          if (!periodData || !prizesData) return;
          setPeriod(periodData);
          setPrizes(prizesData);
          setCurrentTime(periodData.remainingTime);
        })
        .catch(() => {});
    };
    load();
    const poll = setInterval(load, 5000);
    return () => clearInterval(poll);
  }, []);

  useEffect(() => {
    if (!currentTime) return undefined;
    const timer = setInterval(() => {
      setCurrentTime((prev) => {
        if (!prev || prev.isExpired) return prev;
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) seconds -= 1;
        else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else if (days > 0) {
          days -= 1;
          hours = 23;
          minutes = 59;
          seconds = 59;
        } else {
          return { ...prev, isExpired: true };
        }
        return { days, hours, minutes, seconds, isExpired: false };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [!!currentTime]);

  if (!period || !prizes || !currentTime) {
    return (
      <div className="rounded-2xl border-2 border-brand-red bg-white p-8 text-center text-gray-500">
        กำลังโหลดข้อมูลงวด...
      </div>
    );
  }

  const { days, hours, minutes, seconds, isExpired } = currentTime;
  const lastPeriod = prizes.lastDraw?.period;

  const timeUnits = [
    { label: 'วัน', value: days },
    { label: 'ชม.', value: hours },
    { label: 'นาที', value: minutes },
    { label: 'วินาที', value: seconds },
  ];

  return (
    <div className="overflow-hidden rounded-2xl border-2 border-brand-red bg-gradient-to-br from-white via-red-50 to-brand-gold-light/30 shadow-lg">
      <CardContent className="px-4 py-8 sm:px-8 sm:py-10">
        <div className="text-center">
          <span className="inline-block rounded-full bg-brand-red px-6 py-1 text-sm font-bold uppercase tracking-widest text-white">
            MUNGKORN LOTTO
          </span>
          <h2 className="mt-4 text-2xl font-bold text-brand-red sm:text-3xl">
            รางวัลที่ 1
          </h2>
          <p className="mt-1 text-3xl font-bold text-brand-gold sm:text-4xl">
            {formatMoney(prizes.firstPrize)} + ทองคำแท่ง 1 บาท
          </p>
          <p className="mt-2 text-sm text-gray-600">
            ตั๋วใบละ $1 · ออกรางวัลทุกวันอาทิตย์ 18:00 น.
          </p>
        </div>

        <div className="mt-6">
          <p className="mb-2 text-center text-xs font-medium text-gray-500">
            {lastPeriod
              ? `ผลรางวัลที่ 1 งวดล่าสุด (${lastPeriod})`
              : 'ผลรางวัลที่ 1 งวดล่าสุด'}
          </p>
          <PrizeDigits digits={prizes.firstDigits} size="lg" />
        </div>

        {!isExpired ? (
          <>
            <p className="mt-8 text-center text-sm font-medium text-gray-600">
              เหลือเวลาออกรางวัล
            </p>
            <div className="mt-4 flex justify-center gap-2 sm:gap-3">
              {timeUnits.map(({ label, value }) => (
                <div key={label} className="text-center">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl border-2 border-brand-red bg-white text-xl font-bold text-brand-red sm:h-16 sm:w-16 sm:text-2xl">
                    {String(value).padStart(2, '0')}
                  </div>
                  <p className="mt-1 text-xs text-gray-500">{label}</p>
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="mt-8 text-center text-lg font-semibold text-brand-red">
            ถึงเวลาออกรางวัลแล้ว — ระบบกำลังประมวลผล
          </p>
        )}

        <div className="mt-6 rounded-xl bg-brand-red px-4 py-3 text-center text-white">
          <span className="text-sm">งวดที่ {period.period} · รางวัลที่ 1 สะสม </span>
          <span className="text-lg font-bold text-brand-gold">
            {formatMoney(prizes.firstPrize)}
          </span>
        </div>

        <div className="mt-6 flex justify-center">
          <Button size="lg" onClick={onBuyLotteryClick} disabled={isExpired}>
            ซื้อลอตเตอรี่
          </Button>
        </div>
      </CardContent>
    </div>
  );
}
